export default "__VITE_ASSET__Bova7_6e__"